import { AppConstants, ApplicationType } from '@shared/core';
import { CookieService } from 'ngx-cookie-service';

export class CookieHandler {
    constructor(
        private cookieService: CookieService,
        private appConstants: AppConstants,
    ) {}

    public getMcaApplicationCookieValue(): ApplicationType {
        const cookieValue = this.cookieService.get(this.appConstants.applicationTypeCookieName);
        switch (cookieValue) {
            case 'cofus-dunav':
                return ApplicationType.COFUS_DUNAV;
            case 'cofus-globos':
                return ApplicationType.COFUS_GLOBOS;
            default:
                // TODO - Remove default / throw error and handle error
                if (this.appConstants.environment.production) {
                    throw new Error('No application type found');
                }
                return ApplicationType.COFUS_DUNAV;
        }
    }
}
